(function() {
    'use strict';

    angular.module('app.archivoCCSS', []);
})();
